import { css } from '@emotion/css'
import { theme } from '../../styled'
import React from 'react'
import { FormattedMessage } from 'react-intl'

const cssMessage = css`
  font-weight: ${theme.fontWeights.primary.bold};
`

export function ErrorBoundaryMessage() {
  return (
    <div className={cssMessage} data-testid="error-boundary-message">
      <FormattedMessage id="TODO" defaultMessage="An error has occurred" />
    </div>
  )
}
